import { render, staticRenderFns } from "./ButtonTrusteeSendEmail.vue?vue&type=template&id=1481426a&scoped=true&"
import script from "./ButtonTrusteeSendEmail.vue?vue&type=script&lang=ts&"
export * from "./ButtonTrusteeSendEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonTrusteeSendEmail.vue?vue&type=style&index=0&id=1481426a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1481426a",
  null
  
)

export default component.exports